import { useEffect, useState } from 'react';
import { Drawer } from '@mui/material';
import { useSelector } from 'react-redux';
import { sidePanelStyles } from './styles';
import { SidePanelBody } from '../../components/SidePanelBody';
import { SidePanelHeader } from '../../components/SidePanelHeader';
import { getPanelVis } from '../../features/globals/visibilitySlice';
import { selectActiveTheme } from 'GeminiViewerComponent/features/globals/themeSlice';
import { fetchByKey, setByKey } from 'GeminiViewerComponent/helpers';

const GroupOption = {
    TYPE: 'Type',
    TAG: 'Tag',
    TAG_GROUP: 'Tag group',
};

const SIDE_PANEL_GROUP_OPTION = 'sidePanelGroupOption';

const SidePanel = ({ linkTypes, audienceIds, zoneMediaConfigValue }) => {
    const theme = useSelector(selectActiveTheme);
    const classes = sidePanelStyles(theme);
    const isOpen = useSelector((state) => getPanelVis(state));
    const [groupOption, setGroupOption] = useState(fetchByKey(SIDE_PANEL_GROUP_OPTION) ?? GroupOption.TYPE);

    useEffect(() => {
        setByKey(SIDE_PANEL_GROUP_OPTION, groupOption);
    }, [groupOption]);

    const drawerConfig = {
        anchor: 'right',
        open: isOpen,
    };

    return (
        <div>
            <Drawer {...drawerConfig} className={classes.drawer} variant="persistent">
                <div className={classes.sidePanelContainer}>
                    <SidePanelHeader
                        zoneMediaConfigValue={zoneMediaConfigValue}
                        groupOption={groupOption}
                        setGroupOption={setGroupOption}
                    />
                    <SidePanelBody linkTypes={linkTypes} audienceIds={audienceIds} groupOption={groupOption} />
                </div>
            </Drawer>
        </div>
    );
};

export { SidePanel, GroupOption };
